import { gql } from "@apollo/client";

export const SystemIotConnection = gql`
    query SystemIotConnection($id: ID!) {
        system(id: $id) {
            id
            systemType
            iotConnection {
                id
                connectionStatus
                gateway {
                    id
                    imei
                }
            }
        }
    }
`;
